import type {
  OrgRunControlType,
  OrgRunDatePreset,
  OrgRunsSortBy,
  OrgRunsSortState,
  OrgRunStatusGroup,
  OrgRunTestType,
  OrgTestRunsListParams,
} from '../../../types/controlTestRun.ts';

export const DEFAULT_SORT: OrgRunsSortState = {
  key: 'created_at',
  dir: 'desc',
};

export const SORT_DEFAULT_DIR: Record<OrgRunsSortBy, 'asc' | 'desc'> = {
  created_at: 'desc',
  control_id: 'asc',
  workflow_status: 'asc',
  run_number: 'desc',
};

export interface OrgRunFilters {
  datePreset: OrgRunDatePreset;
  status: OrgRunStatusGroup;
  testType: OrgRunTestType;
  controlType: OrgRunControlType;
  search?: string;
  auditYearId?: string | null;
}

const toYyyyMmDd = (d: Date): string => d.toISOString().slice(0, 10);

/** Query params for GET /api/control-test-runs ('all' filters are left out). */
export const buildListParams = (
  page: number,
  pageSize: number,
  filters: OrgRunFilters,
  sort: OrgRunsSortState
): OrgTestRunsListParams => {
  const params: OrgTestRunsListParams = {
    page,
    page_size: pageSize,
    sort_by: sort.key,
    sort_order: sort.dir,
  };
  if (filters.auditYearId) params.audit_year_id = filters.auditYearId;
  if (filters.status !== 'all') params.status = filters.status;
  if (filters.testType !== 'all') params.test_type = filters.testType;
  if (filters.controlType !== 'all') params.control_type = filters.controlType;

  const sk = filters.search?.trim();
  if (sk) params.search = sk;

  if (filters.datePreset !== 'all') {
    const days = filters.datePreset === '7d' ? 7 : filters.datePreset === '30d' ? 30 : 90;
    const to = new Date();
    const from = new Date(to);
    from.setDate(from.getDate() - days);
    params.created_at_from = toYyyyMmDd(from);
    params.created_at_to = toYyyyMmDd(to);
  }

  return params;
};
